
export const pathInResponsiveViews = () => {
  let currentPath = window.location.pathname;
  currentPath = currentPath.split("/")[1]
  const responsiveViews = [
    "times-contrarian",
  ]
  return responsiveViews.includes(currentPath);
}
